export const DEFAULT_TIMESHEETS_PAGE_SIZE = 15;
